import { render, staticRenderFns } from "./changeAvatarModal.vue?vue&type=template&id=14825788&scoped=true"
import script from "./changeAvatarModal.vue?vue&type=script&lang=js"
export * from "./changeAvatarModal.vue?vue&type=script&lang=js"
import style0 from "./changeAvatarModal.vue?vue&type=style&index=0&id=14825788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14825788",
  null
  
)

export default component.exports